goog.provide("shadow.js.shim.module$$carbon$icons_react$es$ArrowUp$default");
shadow.js.shim.module$$carbon$icons_react$es$ArrowUp$default = shadow.js.require(351, {}).default;
